import axios from '../../axiosConfig/metaaxios'
import axios2 from '../../axiosConfig/axios'
export const getRewards = {
  getSearchResult: (query, cb) => {
    axios
      .get(`/rewards?searchText=${query}`, {})
      .then(data => {
        console.log(data)
        cb(null, data)
      })
      .catch(err => {
        console.log(err)
        cb(err, null)
      })
  },
  getUserRewardResult: (token, cb) => {
    console.log(token)
    axios
      .get('/userRewards', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      .then(data => {
        console.log(data)
        cb(null, data)
      })
      .catch(err => {
        console.log(err)
        cb(err, null)
      })
  },

  redeemRewards: (token, data, cb) => {
    axios2
      .post('/redeemReward', data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      .then(data => {
        console.log(data)
        cb(null, data)
      })
      .catch(err => {
        console.log(err)
        cb(err, null)
      })
  }
}
